import { render, staticRenderFns } from "./TranslationModalWrapper.vue?vue&type=template&id=23911128&"
import script from "./TranslationModalWrapper.vue?vue&type=script&lang=js&"
export * from "./TranslationModalWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports